import React, { useState } from 'react';
import theme from '../theme';

function ReviewCard({ review, renderStars, reviewerName }) {
  const [lightbox, setLightbox] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString('it-IT', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  });

  const photos = review.photos || [];
  const comment = review.comment || '';
  const isLong = comment.length > 100;

  const initials = (name) => name
    ? name.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase()
    : '?';

  return (
    <div style={{
      border: '1px solid #e8e8e8',
      borderRadius: theme.radius.lg,
      padding: '12px 14px',
      marginBottom: 10,
      background: theme.colors.white
    }}>

      {/* Riga superiore: avatar + nome/data + stelle */}
      <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing.sm, marginBottom: 8 }}>

        {/* Avatar iniziali */}
        <div style={{
          width: 36, height: 36, borderRadius: theme.radius.circle,
          background: theme.colors.primaryLight, display: 'flex', alignItems: 'center',
          justifyContent: 'center', fontSize: theme.font.size.sm, fontWeight: 600,
          color: theme.colors.primary, flexShrink: 0
        }}>
          {initials(reviewerName || review.reviewer_email)}
        </div>

        {/* Nome + data */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: theme.font.size.base, fontWeight: 600, color: '#222', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {reviewerName || review.reviewer_email}
          </div>
          <div style={{ fontSize: theme.font.size.xs, color: '#aaa' }}>{formatDate(review.created_at)}</div>
        </div>

        {/* Stelle */}
        <div style={{ display: 'flex', gap: 1, flexShrink: 0 }}>
          {renderStars(review.stars)}
        </div>
      </div>

      {/* Commento con troncamento */}
      {comment && (
        <div>
          <p style={{
            margin: '0 0 4px', fontSize: theme.font.size.base, color: '#444', lineHeight: 1.5,
            display: '-webkit-box', WebkitLineClamp: expanded ? 'unset' : 2,
            WebkitBoxOrient: 'vertical', overflow: 'hidden'
          }}>
            "{comment}"
          </p>
          {isLong && (
            <button
              onClick={() => setExpanded(e => !e)}
              style={{
                background: 'none', border: 'none', padding: 0,
                fontSize: theme.font.size.sm, color: theme.colors.primary, cursor: 'pointer'
              }}
            >
              {expanded ? 'Mostra meno' : 'Mostra tutto'}
            </button>
          )}
        </div>
      )}

      {/* Foto in strip orizzontale */}
      {photos.length > 0 && (
        <div style={{ display: 'flex', gap: 6, marginTop: 10, overflowX: 'auto' }}>
          {photos.map((url, index) => (
            <div
              key={index}
              onClick={() => setLightbox(index)}
              style={{
                width: 56, height: 56, borderRadius: theme.radius.sm, overflow: 'hidden',
                flexShrink: 0, cursor: 'pointer'
              }}
            >
              <img src={url} alt={`foto ${index + 1}`}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          ))}
        </div>
      )}

      {/* Lightbox */}
      {lightbox !== null && (
        <div onClick={() => setLightbox(null)} style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.9)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <button onClick={e => { e.stopPropagation(); setLightbox(l => l > 0 ? l - 1 : photos.length - 1); }}
            style={{ position: 'absolute', left: 16, background: 'rgba(255,255,255,0.2)', border: 'none', color: theme.colors.white, fontSize: 28, cursor: 'pointer', borderRadius: theme.radius.circle, width: 44, height: 44 }}>‹</button>
          <img src={photos[lightbox]} alt="foto"
            style={{ maxWidth: '90%', maxHeight: '80vh', objectFit: 'contain', borderRadius: theme.radius.sm }} />
          <button onClick={e => { e.stopPropagation(); setLightbox(l => l < photos.length - 1 ? l + 1 : 0); }}
            style={{ position: 'absolute', right: 16, background: 'rgba(255,255,255,0.2)', border: 'none', color: theme.colors.white, fontSize: 28, cursor: 'pointer', borderRadius: theme.radius.circle, width: 44, height: 44 }}>›</button>
          <button onClick={() => setLightbox(null)}
            style={{ position: 'absolute', top: 16, right: 16, background: 'rgba(255,255,255,0.2)', border: 'none', color: theme.colors.white, fontSize: 20, cursor: 'pointer', borderRadius: theme.radius.circle, width: 36, height: 36 }}>✕</button>
          <div style={{ position: 'absolute', bottom: 20, color: theme.colors.white, fontSize: theme.font.size.base }}>
            {lightbox + 1} / {photos.length}
          </div>
        </div>
      )}

    </div>
  );
}

export default ReviewCard;